import React from "react";
import ReactDOM from "react-dom/client";
import "./fonts.css";
import "./globals.css";
import App from "./App";

// When a new deployment changes chunk hashes, cached JS bundles reference chunk
// filenames that no longer exist on the server. Vite fires `vite:preloadError`
// for any failed dynamic import (including vendor-internal imports such as
// mermaid's per-diagram-type sub-chunks). Reload once — the fresh bundle and all
// its chunk URLs come from the new deployment, so the error can't recur.
// sessionStorage guard prevents an infinite reload loop if the file genuinely
// does not exist rather than being a transient stale-cache miss.
window.addEventListener("vite:preloadError", () => {
  const RELOAD_KEY = "vite-chunk-reload";
  if (!sessionStorage.getItem(RELOAD_KEY)) {
    sessionStorage.setItem(RELOAD_KEY, "1");
    window.location.reload();
  }
});

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element");

ReactDOM.createRoot(root).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
